import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgCheckboxDisabledSelected24 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" fillRule="evenodd" d="M25 27H7c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h18c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2m1-20c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1zM14.5 20.41l-3.71-3.71a.996.996 0 1 1 1.41-1.41l2.29 2.29 5.29-5.29a.996.996 0 1 1 1.41 1.41l-6.71 6.71z" clipRule="evenodd" /></SvgIcon>;
};
const Memo = memo(SvgCheckboxDisabledSelected24);
export default Memo;